if (typeof PartnershipSlideshowController === 'undefined') {
	/*
	* Slideshow controller for image/video with tag and detail type of slideshow.
	*/
	var PartnershipSlideshowController = (function ($) {
		var ret, slideshowWrapper, slideshow, count;

		function ready() {
			slideshowWrapper = $(".partnership.slideshow");
			slideshow = slideshowWrapper.children('.slides');
			slick();
		}

		function slick() {
			if (typeof $.fn.slick === 'function') {
				slideshowWrapper.each(function (idx, item) {
					var slideshow = $(this);
					var carousel = slideshow.children('.slides');
					var carouselId = 'slideshow_carousel_' + idx;
					this.id = carouselId;
					carousel.on('init', window.SlickSettings.slickInit);
					carousel.on("afterInit", window.SlickSettings.slickAfterInit);
					carousel.slick({
						speed: 444,
						infinite: true,
						easing: 'easeOutQuart',
						dots: false,
						prevArrow: '#' + carouselId + " .prev",
						nextArrow: '#' + carouselId + " .next"
					});
				});
			}
		}

		$(ready);
		return ret;
	})(jQuery);
}